"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class BusinessService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    fetchBusinessList(businessFetchPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/list?page=${businessFetchPayload.pageNumber}&limit=${businessFetchPayload.limit}`;
                let response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (err) {
                throw new Error('Failed to fetch');
            }
        });
    }
    createBusiness(businessCreatePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/register`;
                businessCreatePayload = JSONbig.stringify(businessCreatePayload);
                let response = yield axios_1.default.post(url, businessCreatePayload, {
                    headers: header
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (err) {
                throw new Error(err.response.data.message);
            }
        });
    }
    updateBusiness(businessCreatePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/edit`;
                businessCreatePayload = JSONbig.stringify(businessCreatePayload);
                let response = yield axios_1.default.put(url, businessCreatePayload, {
                    headers: header
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (err) {
                throw new Error(err.response.data.message);
            }
        });
    }
    fetchHostAllBusiness(fetchPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/get_all_Buisness?page=${fetchPayload.pageNumber}&limit=${fetchPayload.limit}`;
                let response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (err) {
                throw new Error('Failed to fetch');
            }
        });
    }
    fetchBusinessById() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/get_business_by_Id`;
                let response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.data;
                localStorage.setItem('business_data', JSONbig.stringify(responseData));
                return responseData;
            }
            catch (err) {
                throw new Error('Failed to fetch');
            }
        });
    }
}
exports.BusinessService = BusinessService;
